import { render } from "./AdminBookingsReoccurring.vue?vue&type=template&id=3a5632ae&scoped=true"
import script from "./AdminBookingsReoccurring.vue?vue&type=script&lang=js"
export * from "./AdminBookingsReoccurring.vue?vue&type=script&lang=js"

import "./AdminBookingsReoccurring.vue?vue&type=style&index=0&id=3a5632ae&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5632ae"]])

export default __exports__